/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function addItemToCart(variant_id, qty, cart_btn) {
    const data = {
        id: variant_id,
        quantity: qty
    };

    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
    .then(response => {
        if (!response.ok) {
            throw new Error(`Cart add failed: ${response.status}`);
        }
        return response.json();
    })
    .then(() => {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

        // Remove loading state
        const loadingEl = document.querySelector('.bss-loading-btn');
        if (loadingEl) loadingEl.remove();
        cart_btn.querySelector('span').classList.remove('hidden');

        // Open cart drawer
        const cartDrawerIcon = document.querySelector('[data-action="open-drawer"][data-drawer-id="sidebar-cart"]');
        if (cartDrawerIcon) cartDrawerIcon.click();
    })
    .catch(error => {
        console.error('Error adding item to cart:', error);

        // Remove loading state even on failure so the button isn't stuck
        const loadingEl = document.querySelector('.bss-loading-btn');
        if (loadingEl) loadingEl.remove();
        cart_btn.querySelector('span').classList.remove('hidden');
    });
}

function handleAddToCartClick(btn) {
    const ID = btn.dataset.var_id;
    
    // Show loading state
    btn.querySelector('span').classList.add('hidden');
    btn.insertAdjacentHTML('beforeend', `<div class="bss-loading-btn collection_loading_btn"><div class="bss-loader"></div></div>`);

    addItemToCart(ID, 1, btn);
}
